.primary {
	font-weight: 500;
}

.connect {
	margin-inline-start: auto;
}
